import { File, HoursOfOperation } from '../../Types';

export interface CommercialERSInformation {
  oncall_sds_dashboard: boolean,
  is_fixpix_location: boolean,
  ers_mechanical_services: {
    do_you_have_trucks: boolean,
    ers_mechanical_services_provided: {
      brakes_repair: boolean,
      diagnostic_services: boolean,
      dot_inspection: boolean,
      electric_vehicle_charging: boolean,
      fuel_delivery: boolean,
      jump_starts: boolean,
      lights: boolean,
      lockouts: boolean,
      suspension_repair: boolean,
      towing: boolean,
    },
    mechanical_same_hours_as_tires_ers_services: boolean,
    number_of_trucks: number,
    provides_247365_ers_service: boolean,
    photo_of_truck: File
  },
  ers_tire_services: {
    do_you_have_trucks: boolean,
    number_of_trucks: number,
    provides_247365_ers_service: boolean,
  },
  rv_motor_coach: {
    motor_coach_dealer: boolean,
    rv_dealer: boolean,
  },
  mechanical_hours_of_operation: HoursOfOperation,
  tire_services_hours_of_operation: HoursOfOperation,
  is_autodispatch_oncall_cases: boolean,
  autodispatch_after_hours: boolean,
  autodispatch_phone_number?: string | null,
  autodispatch_is_phone_tree: boolean | undefined,
  autodispatch_wait_period_for_pt: string | undefined,
  autodispatch_pt_sequence: string[] | undefined,
  autodispatch_is_phone_validated: boolean | undefined,
}

export const mechanicalServicesFields = {
  // customerConvenience
  'ers_mechanical_services.ers_mechanical_services_provided.brakes_repair': 'Brakes repair',
  'ers_mechanical_services.ers_mechanical_services_provided.diagnostic_services': 'Diagnostic services',
  'ers_mechanical_services.ers_mechanical_services_provided.dot_inspection': 'DOT Inspection',
  'ers_mechanical_services.ers_mechanical_services_provided.electric_vehicle_charging': 'Electric vehicle charging',
  'ers_mechanical_services.ers_mechanical_services_provided.fuel_delivery': 'Fuel delivery',
  'ers_mechanical_services.ers_mechanical_services_provided.jump_starts': 'Jump starts',
  'ers_mechanical_services.ers_mechanical_services_provided.lights': 'Lights',
  'ers_mechanical_services.ers_mechanical_services_provided.lockouts': 'Lockouts',
  'ers_mechanical_services.ers_mechanical_services_provided.suspension_repair': 'Suspension repair',
  'ers_mechanical_services.ers_mechanical_services_provided.towing': 'Towing',
};
